import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { RootState } from "store/rootReducer";
import { useForecastStore } from "stores/forecast";

/**
 * Receives cross-tab redux-state-sync updates for forecast selections and
 * forwards them to the local ForecastStore.
 *
 * ForecastStoreCrossTabBridge (main tab) writes changed ForecastStore values to
 * the Redux arpsSlice so that redux-state-sync propagates them to other tabs.
 * This hook is the receiving end on the popout tab: it reads those deprecated arps
 * fields via useSelector and mirrors them into the local ForecastStore via plain
 * setState, bypassing the backup/color-sync side effects in setCheckedGlobalTypeWells
 * since the popout is a mirror, not the source of truth.
 */
export function usePopoutForecastSync() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore -- intentional: deprecated fields used as cross-tab sync conduit
  const syncedCheckedGlobalTypeWells = useSelector(
    (state: RootState) => state.arps.checkedGlobalTypeWells,
    shallowEqual
  );
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore -- intentional: deprecated fields used as cross-tab sync conduit
  const syncedCheckedGlobalForecasts = useSelector(
    (state: RootState) => state.arps.checkedGlobalForecasts,
    shallowEqual
  );

  useEffect(() => {
    useForecastStore.setState({ checkedGlobalTypeWells: syncedCheckedGlobalTypeWells });
  }, [syncedCheckedGlobalTypeWells]);

  useEffect(() => {
    useForecastStore.setState({ checkedGlobalForecasts: syncedCheckedGlobalForecasts });
  }, [syncedCheckedGlobalForecasts]);
}
